export function resolveImg(path) {
  if (path) {
    if (path.startsWith('http') || path.startsWith('//') || path.startsWith('/src') || path.startsWith('/assets')) {
      return path
    } else {
      if (path.startsWith('/')) {
        path = path.substring(1)
      }
      // return 'https://bm-archives.obs.cn-east-3.myhuaweicloud.com:443/' + path
      return 'https://bm-archives-1358098719.cos.ap-guangzhou.myqcloud.com/' + path
      // return 'https://bm-archives.obs.cn-east-3.myhuaweicloud.com:443/' + path
    }
  } else {
    return ''
  }
}
